import { useContext } from 'react'
import { EditorContext } from '../context'

export function useEditorContext() {
  const { setCanvas, canvas, activeObject, setActiveObject, editor, contextMenuAnchor, setContextMenuAnchor } =
    useContext(EditorContext)

  return {
    setCanvas,
    canvas,
    activeObject,
    setActiveObject,
    editor,
    contextMenuAnchor,
    setContextMenuAnchor,
  }
}
